import { RemotePattern } from 'next/dist/shared/lib/image-config'

export const remotePatterns: RemotePattern[] = [
  {
    protocol: 'https',
    hostname: 'cdn.sanity.io',
    pathname: '/images/**',
  },
  {
    protocol: 'https',
    hostname: 'cdn.shopify.com',
    pathname: '/s/files/**',
  },
]
